const RISK_PALETTE = {
  low: {
    color: '#1f6f43',
    backgroundColor: '#e8f5ed',
    borderColor: '#72b58c',
  },
  medium: {
    color: '#8a5a00',
    backgroundColor: '#fff5d6',
    borderColor: '#d8ae4b',
  },
  high: {
    color: '#a52a2a',
    backgroundColor: '#fdeaea',
    borderColor: '#d88181',
  },
  unknown: {
    color: '#606266',
    backgroundColor: '#f4f4f5',
    borderColor: '#bfc2c7',
  },
};

export function normalizeAmlRisk(risk) {
  return Object.prototype.hasOwnProperty.call(RISK_PALETTE, risk)
    ? risk
    : 'unknown';
}

export function amlRiskStyle(risk) {
  return RISK_PALETTE[normalizeAmlRisk(risk)];
}

export function amlRiskLabel(risk) {
  return {
    low: 'Низкий риск',
    medium: 'Средний риск',
    high: 'Высокий риск',
    unknown: 'Риск не определён',
  }[normalizeAmlRisk(risk)];
}

export function amlRiskTagType(risk) {
  return {
    low: 'success',
    medium: 'warning',
    high: 'danger',
    unknown: 'info',
  }[normalizeAmlRisk(risk)];
}

export function amlRiskFromLevel(level) {
  const normalized = String(level || '').toLowerCase();
  if (/critical|high|крит|высок/.test(normalized)) {
    return 'high';
  }
  if (/medium|сред/.test(normalized)) {
    return 'medium';
  }
  if (/low|clean|низ|чист/.test(normalized)) {
    return 'low';
  }
  return 'unknown';
}

export function formatAmlPercent(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) {
    return '—';
  }
  return `${number.toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  })}%`;
}

export function formatAmlDate(value, short = false) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString(
    'ru-RU',
    short
      ? {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        }
      : undefined,
  );
}
